import { render, staticRenderFns } from "./JobDashboard.vue?vue&type=template&id=cdd4a576"
import script from "./JobDashboard.vue?vue&type=script&lang=js"
export * from "./JobDashboard.vue?vue&type=script&lang=js"
import style0 from "./JobDashboard.vue?vue&type=style&index=0&id=cdd4a576&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports